angular.module('jv.register.form.validation.factory', [])
    .factory('jvUserRegistrationValidationFAC', [function () {
        return function(triggerValidation){
            var passwordStrength = function(_password){
                if(_password){
                    var pattern=/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
                    return _password.match(pattern);
                }
                return false;
            };
            var reTypePassword = function(_password, _confirmPassword){
                if(_password && _confirmPassword){
                    return _password === _confirmPassword;
                }
                return false;
            };

            return {
                input : function(value1, value2, validationType, ignoreValidation, forceTriggerValidation){
                    var result = true;
                    if(!ignoreValidation){
                        if(triggerValidation || forceTriggerValidation){
                            switch(validationType){
                                case 'value':
                                    result = !!value1;
                                    break;
                                case 'mismatch':
                                    result = reTypePassword(value1,value2);
                                    break;
                                case 'strength':
                                    result = value1 ? passwordStrength(value1) : true;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    return result;
                }
            };
        };
    }]);